<template>
    <div>
        <v-card>
            <v-card-title>
                <span>Delay Policies</span>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="dialog=true">New</v-btn>
            </v-card-title>
            <v-data-table :headers="headers" :items="package" :loading="loading">
                <template v-slot:items="props">
                    <td class="text-xs-left">{{ props.item.id }}</td>
                    <td class="text-xs-left">{{ props.item.from }}</td>
                    <td class="text-xs-left">{{ props.item.to }}</td>
                    <td class="text-xs-left">{{ props.item.ratio}}</td>
                    <td class="text-xs-left">
                        <v-icon
                                small
                                @click="deleteItem(props.item)"
                        >
                            delete
                        </v-icon>
                    </td>
                </template>
            </v-data-table>
        </v-card>
        <v-dialog v-model="dialog" width="40%">
            <v-card>
                <v-card-title>
                    Add New Delay Policy
                </v-card-title>
                <v-card-text>
                    <v-text-field v-model="model.from" label="From"></v-text-field>
                    <v-text-field v-model="model.to" label="To"></v-text-field>
                    <v-text-field v-model="model.ratio" label="Ratio"></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" @click="save" :disabled="loading">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";

    export default {
        name: "DelayPolicies",
        title: "Delay Policies",
        components: {DataTable},
        data() {
            return {
                headers: [
                    {text: 'ID', value: 'id'},
                    {text: 'From', value: 'from'},
                    {text: 'To', value: 'to'},
                    {text: 'Ratio', value: 'ratio'},
                    {text: 'Actions', value: 'actions'},
                ],
                package: [],
                loading: false,
                search: '',
                dialog: false,
                model: {
                    employment_type_id: this.$route.params.id
                }
            };
        },
        mounted() {
            this.getData();
        },
        methods: {
            reset()
            {
                this.model.employment_type_id = this.$route.params.id;
            },
            getData() {
                this.loading = true;
                this.axios.get(this.api.ACTIONS.EMPLOYMENT_TYPE_DELAY_POLICY(this.$route.params.id))
                    .then(res => this.package = res.data.data)
                    .catch(err => console.log(err.message))
                    .finally(() => this.loading = false);
            },
            getDeleteData(item) {
                let method = "DELETE";
                let url = 'delay_policy' + "/" + item.id;
                return {data: {_method: method}, url};
            },
            save() {
                this.loading = true;
                this.axios.post(`delay_policy`, this.model)
                    .then((response) => {
                        this.getData();
                        this.dialog = false;
                        window.getApp.$emit("SHOW_TOAST", response.data.message);
                        this.reset()
                    })
                    .catch(({response}) => {
                        if (response && response.data && response.data.message)
                            window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
                        else {
                            window.getApp.$emit('SHOW_TOAST', "Couldn't save (error happened check error log)!", 'red');
                        }
                    })
                    .finally(() => this.loading = false);
            },
            deleteItem(item){
                let method = "DELETE";
                let url = 'delay_policy' + "/" + item.id;
                confirm('Are you sure you want to delete this item?') && (() => {
                    this.loading = true;
                    const props = this.getDeleteData(item);
                    this.axios.post(props.url, props.data).then(
                        () => {
                            window.getApp.$emit("SHOW_TOAST", "Deleted", "green");
                        }
                    ).catch(
                        ({response}) => {
                            if (response && response.data && response.data.message)
                                window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
                            else {
                                window.getApp.$emit('SHOW_TOAST', 'Error Happened (Check error log)', "red");
                                console.log(data);
                            }
                        }
                    )
                        .finally(() => {
                            this.loading = false;
                        });
                })()

            },
        }
    }
</script>

<style scoped>

</style>
